module.exports = __webpack_public_path__ + "static/img/95009A_1_C_20240619_LC.2b22244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95009A_1_C_20240619_LC.png
// module id = 9gj3
// module chunks = 0